module.exports = __webpack_public_path__ + "img/owler.9797105c.png";